export default function MCostQtyInputDialog(props) {
  return <div></div>;
}
